import Lookup from 'src/componentes/select2';

const StatusOrganizacao = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      clearable={clearable}
      labelKey="descricao"
      valueKey="id"
      url="/StatusOrganizacaoLookup"
      {...props}
    />
  );
};

export default StatusOrganizacao;
